import axios from '../request/http';


const finance = {
    // 提现列表
    getFinanceList(params) {
        return axios.get("/admin/cash/list", {params});
    },
    // 微信提现
    cashAccept(data) {
        return axios.post("/admin/cash/accept", data);
    },
    // 拒绝提现
    cashReject(data) {
        return axios.post("/admin/cash/reject", data);
    },
     // 查询账户信息
     queryAcctinfo(params) {
        return axios.get("/admin/lianlianpay/queryAcctinfo", {params});
    },
    // 获取密码控件token
    getPasswordElementToken(params) {
        return axios.get("/admin/lianlianpay/getPasswordElementToken", {params});
    },
    // 内部转账
    innerAccountTransfer(data) {
        return axios.post("/admin/lianlianpay/innerAccountTransfer", data);
    },
    // 转账短信验证
    transferSmsverify(data) {
        return axios.post("/admin/lianlianpay/transferSmsverify", data);
    }
}

export default finance;


// WEBPACK FOOTER //
// ./src/api/finance.js